import {parseISO} from "date-fns";


export const contractsMapper = (apiResponse) => {
    return {
        requestContract: apiResponse.requestContract ? requestContractMapper(apiResponse.requestContract) : null,
        adContracts: Array.isArray(apiResponse.adContracts) ? apiResponse.adContracts.map(adContractMapper) : [],
    }
}

export const requestContractMapper = (apiResponse) => {
    const settings = apiResponse.settings ?? {};

    return {
        email: apiResponse.email,
        expiration: apiResponse.expiration,
        blocked: apiResponse.blocked,
        logo: apiResponse.logo,
        expired: apiResponse.expired,
        valid: apiResponse.valid,
        settings: {
            emailProvider: settings.emailProvider,
            notifyDefaultEmailProvider: settings.notifyDefaultEmailProvider,
            defaultConfirmationPolicy: settings.defaultConfirmationPolicy,
            defaultCancellationPolicy: settings.defaultCancellationPolicy,
            defaultDepositPercentage: settings.defaultDepositPercentage,
            defaultQuoteExpirationInDays: settings.defaultQuoteExpirationInDays,
            defaultForewarningForRefundInDays: settings.defaultForewarningForRefundInDays,
            lastVersionNotified: settings.lastVersionNotified,
            requestAutoReplyEnabled: settings.requestAutoReplyEnabled,
            defaultTouristTaxPolicy: settings.defaultTouristTaxPolicy,
            defaultTouristTaxUnitPrice: settings.defaultTouristTaxUnitPrice,
            theme: {
                primaryColor: settings.theme?.primaryColor,
                primaryBackgroundColor: settings.theme?.primaryBackgroundColor,
                secondaryBackgroundColor: settings.theme?.secondaryBackgroundColor,
                titleAlignment: settings.theme?.titleAlignment,
            }
        },
        accommodationUnitsSettings: Array.isArray(apiResponse.accommodationUnitsSettings) ? apiResponse.accommodationUnitsSettings.map(accommodationUnitSettingsMapper) : [],
    }
}

export const accommodationUnitSettingsMapper = (apiResponse) => {
    return {
        accommodationUnitId: apiResponse?.accommodationUnitId,
        checkInFrom: apiResponse?.checkInFrom ? parseISO(apiResponse.checkInFrom) : null,
        checkOutBefore: apiResponse?.checkOutBefore ? parseISO(apiResponse.checkOutBefore) : null,
    }
}

export const adContractMapper = (apiResponse) => {
    return {
        homeId: apiResponse?.homeId,
        expiration: apiResponse?.expiration,
        blocked: apiResponse?.blocked,
        expired: apiResponse?.expired,
        valid: apiResponse?.valid,
    }
}